export default "__VITE_ASSET__He_UX2sr__"